module.exports = __webpack_public_path__ + "static/media/vencedor.dcfb6cac.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/maiz/climasense/roya_maiz/preventiva/vencedor.png
// module id = 1721
// module chunks = 3